import { create } from 'zustand';

import { ApiCaseResponseV2 } from '@/shared/api/generated/data-contracts';

export type CasesStoreState = {
  cases: ApiCaseResponseV2[];
  isLoading: boolean;
};

export type CasesStore = CasesStoreState & {
  isInitialized: boolean;

  setCases: (cases: ApiCaseResponseV2[]) => void;
  addCase: (newCase: ApiCaseResponseV2) => void;
  updateCase: (caseId: string, updates: Omit<Partial<ApiCaseResponseV2>, 'id'>) => void;
  removeCase: (caseId: string) => void;
  setLoading: (isLoading: boolean) => void;
  setInitialized: (isInitialized: boolean) => void;
  clear: () => void;
};

export const useCasesStore = create<CasesStore>((set, get) => ({
  cases: [],
  isLoading: false,
  isInitialized: false,

  setCases: (cases) => set({ cases }),
  addCase: (newCase) =>
    set(() => {
      const existingIndex = get().cases.findIndex((c) => c.id === newCase.id);
      if (existingIndex !== -1) {
        const updatedCases = [...get().cases];
        updatedCases[existingIndex] = newCase;
        return { cases: updatedCases };
      }
      return { cases: [newCase, ...get().cases] };
    }),
  updateCase: (caseId, data) =>
    set(() => ({
      cases: get().cases.map((c) => (c.id === caseId ? { ...c, ...data } : c)),
    })),
  removeCase: (caseId) =>
    set(() => ({
      cases: get().cases.filter((c) => c.id !== caseId),
    })),
  setLoading: (isLoading) => set({ isLoading }),
  setInitialized: (isInitialized) => set({ isInitialized }),
  clear: () => set({ cases: [], isInitialized: false }),
}));
